import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_geometric',
    dependencies: [
        'levels_maths/proportionality_advanced'
    ]
})


let knight = new Image()
knight.src = 'img/knight.png'



//FIXME
function addLengthArrows (geoScreen, {originX, originY, color, x, y, length: text}) {

    //let length = Math.sqrt(params.x * params.x + params.y * params.y)

    let v = {
        originX,
        originY,
        color,
        x,
        y,
        branchLength: Math.min(0.2, 4 / geoScreen.screen.scale)
    }

    geoScreen.addVector(v)


    let v2 = {
        originX: v.originX + v.x,
        originY: v.originY + v.y,
        color,
        x: -v.x,
        y: -v.y,
        branchLength: Math.min(0.2, 4 / geoScreen.screen.scale)
    }

    geoScreen.addVector(v2)

    let textCenter


    if (y === 0) {
        textCenter = {
            x: originX + x / 2,
            y: originY + y / 2 - 0.7
        }
    } else {
        textCenter = {
            x: originX + x / 2 + 0.4,
            y: originY + y / 2
        }
    }

    if (text === '?') {
        geoScreen.addAnswerPlaceholder(textCenter)
    } else {
        geoScreen.addText({
            text,
            center: textCenter,
            color
        })
    }

}




function addKnightImage (geoScreen, {position, width, lengthToGuess, askForHeight}) {

    geoScreen.addVisibleZone({
        x: position.x,
        y: position.y,
        radius: 0
    })

    geoScreen.addVisibleZone({
        x: position.x,
        y: position.y + width * 2,
        radius: 0
    })

    geoScreen.addImage({
        image: knight,
        width,
        bottomCenter: position
    })



    addLengthArrows(geoScreen, {
        originX: position.x - 0.47 * width,
        originY: position.y - 0.2,
        x: 0.88 * width,
        y: position.y,
        length: width,
        color:  '#d7902a'
    })


    if (lengthToGuess === 'man') {
        addLengthArrows(geoScreen, {
            originX: position.x + 0.7 * width,
            originY: position.y + 0.15 * width,
            x: 0,
            y: width * 1.5,
            length: askForHeight ? '?' : width * 1.5,
            color:  '#113E53'
        })
    }

    if (lengthToGuess === 'full') {
        addLengthArrows(geoScreen, {
            originX: position.x + 0.7 * width,
            originY: position.y + 0.05 * width,
            x: 0,
            y: width * 2,
            length: askForHeight ? '?' : width * 2,
            color:  '#113E53'
        })
    }



}



function common (q, width, otherWidth, lengthToGuess) {
    let geoScreen = q.addGeoScreen({
        noAxes: true,
        noGrid: true
    })

    addKnightImage(geoScreen, {
        position: {
            x: 0,
            y: 0
        },
        lengthToGuess,
        width
    })


    addKnightImage(geoScreen, {
        position: {
            x: (width + otherWidth) * 1.2,
            y: 0
        },
        width: otherWidth,
        lengthToGuess,
        askForHeight: true
    })

    if (lengthToGuess === 'full') {
        q.answer = 2 * otherWidth
    }

    if (lengthToGuess === 'man') {
        q.answer = Math.round(1.5 * otherWidth * 10) / 10
    }

    q.addBadChoices(
        otherWidth,
        width * otherWidth,
        3 * otherWidth,
        () => random.intBetween(1, 9)
    )
}



level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {width: 2, otherWidth: 4}},
            {1: {width: 2, otherWidth: 1}},
            {1: {width: 1, otherWidth: 3}},
            {all: [
                {width: 1, otherWidth: 2},
                {width: 2, otherWidth: [3, 5, 6]},
                {width: 3, otherWidth: [1, 2, 4]}
            ]}
        ], function (choices) {
            common(q, choices.width, choices.otherWidth, 'full')
        })

    }
})



level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {width: 2, otherWidth: 4}},
            {1: {width: 2, otherWidth: 1}},
            {1: {width: 1, otherWidth: 3}},
            {all: [
                {width: 1, otherWidth: 2},
                {width: 2, otherWidth: [3, 5, 6]},
                {width: 3, otherWidth: [1, 2, 4]}
            ]}
        ], function (choices) {
            common(q, choices.width, choices.otherWidth, 'man')
        })

    }
})



export default level

